// extracted by mini-css-extract-plugin
export var description = "styles-module--description--a3146";
export var item = "styles-module--item--b199f";
export var subdesc = "styles-module--subdesc--ec999";
export var title = "styles-module--title--73021";